app.controller('popupBusinessIntelligenceMapController', ['$scope', '$state', '$timeout', '$translate', '$mdToast', '$mdDialog', 'objectHelper', 'applicationModel', 'saikuModel', 'repoObject',
    function ($scope, $state, $timeout, $translate, $mdToast, $mdDialog, objectHelper, applicationModel, saikuModel, repoObject) {

        var voivodenshipMap = {
            'mazowieckie': 'PL.MZ',
            'wielkopolskie': 'PL.WP',
            'kujawsko-pomorskie': 'PL.KP',
            'dolno?l?skie': 'PL.DS',
            'warmi?sko-mazurskie': 'PL.WN',
            '?ódzkie': 'PL.LD',
            '?wietokrzyskie': 'PL.SK',
            'lubelskie': 'PL.LU',
            'podkarpackie': 'PL.PK',
            'opolskie': 'PL.OP',
            'ma?opolskie': 'PL.MA',
            'pomorskie': 'PL.PM',
            'zachodniopomorskie': 'PL.ZP',
            'lubuskie': 'PL.LB',
            '?l?skie': 'PL.SL',
            'podlaskie': 'PL.PD'
        };

        var countriesMap = {
            'Denmark': 'dk',
            'Faroe Islands': 'fo',
            'Croatia': 'hr',
            'Netherlands': 'nl',
            'Estonia': 'ee',
            'Bulgaria': 'bg',
            'Spain': 'es',
            'Italy': 'it',
            'San Marino': 'sm',
            'Vatican': 'va',
            'Turkey': 'tr',
            'Malta': 'mt',
            'France': 'fr',
            'Norway': 'no',
            'Germany': 'de',
            'Ireland': 'ie',
            'Ukraine': 'ua',
            'Finland': 'fi',
            'Sweden': 'se',
            'Russia': 'ru',
            'United Kingdom': 'gb',
            'Cyprus': 'cy',
            'Portugal': 'pt',
            'Greece': 'gr',
            'Lithuania': 'lt',
            'Slovenia': 'si',
            'Bosnia and Herzegovina': 'ba',
            'Monaco': 'mc',
            'Albania': 'al',
            'Cyprus No Mans Area': 'cnm',
            'Northern Cyprus': 'nc',
            'Republic of Serbia': 'rs',
            'Romania': 'ro',
            'Montenegro': 'me',
            'Liechtenstein': 'li',
            'Austria': 'at',
            'Slovakia': 'sk',
            'Hungary': 'hu',
            'Andorra': 'ad',
            'Luxembourg': 'lu',
            'Switzerland': 'ch',
            'Belgium': 'be',
            'Kosovo': 'kv',
            'Poland': 'pl',
            'Macedonia': 'mk',
            'Latvia': 'lv',
            'Belarus': 'by',
            'Iceland': 'is',
            'Moldova': 'md',
            'Czech Republic': 'cz'
        };

        function generateData(data) {
            switch (repoObject.name) {
                case 'Visits_by_Country.saiku':
                    data.cellset.forEach(function (row, index) {
                        if(index > 0) {
                            $scope.data.push({
                                code: countriesMap[row[0].value],
                                value: Number(row[1].value)
                            });
                        }
                    });
                    if(data.cellset && data.cellset[0] && data.cellset[0][1]) {
                        $scope.seriesName = data.cellset[0][1].value;
                    }
                    $scope.ready = true;
                    $scope.type = "europe";
                    break;
                case 'Patients_by_voivodenship.saiku':
                case 'Visits_by_voivodenship.saiku':
                    data.cellset.forEach(function (row, index) {
                        if(index > 0) {
                            $scope.data.push({
                                code: voivodenshipMap[row[0].value],
                                value: Number(row[1].value)
                            });
                        }
                    });
                    if(data.cellset && data.cellset[0] && data.cellset[0][1]) {
                        $scope.seriesName = data.cellset[0][1].value;
                    }
                    $scope.ready = true;
                    break;
                case 'Patients_by_Country_Allergy.saiku':
                case 'Patients_by_Country_Drugs.saiku':
                case 'Visits_by_ICD9_Country.saiku':
                case 'Visits_by_ICD10_Country.saiku':
                case 'Visits_by_ICF_Country.saiku':
                    var countries = {};
                    data.cellset.forEach(function (row, index) {
                        if(index === 0) {
                            row.forEach(function (cell, cellIndex) {
                                countries[cellIndex] = cell.value;
                            });
                        }
                        if(index > 1) {
                            $scope.dataMap[index] = {};
                            var data = [];
                            row.forEach(function (cell, cellIndex) {
                                if(cellIndex > 0) {
                                    data.push({
                                        code: countriesMap[countries[cellIndex]],
                                        value: Number(cell.value)
                                    });
                                }
                            });
                            if(repoObject.name === 'Patients_by_Country_Allergy.saiku' && row[0].value !== '#null') {
                                $scope.dataMap[index].name = $translate.instant('T.ENUM.ALLERGY_TYPE.' + row[0].value);
                            } else {
                                $scope.dataMap[index].name = row[0].value;
                            }
                            $scope.dataMap[index].data = data;


                        }
                    });
                    $scope.options = Object.keys($scope.dataMap).map(function (index) {
                        return {
                            id: index,
                            name: $scope.dataMap[index].name
                        }
                    });
                    if(data.cellset && data.cellset[1] && data.cellset[1][1]) {
                        $scope.seriesName = data.cellset[1][1].value;
                    }
                    $scope.type = "europe";
                    break;
                case 'Patients_by_voivodenship_allergy.saiku':
                case 'Patients_by_voivodenship_drugs.saiku':
                    var voivodenships = {};
                    data.cellset.forEach(function (row, index) {
                        if(index === 0) {
                            row.forEach(function (cell, cellIndex) {
                                voivodenships[cellIndex] = cell.value;
                            });
                        }
                        if(index > 1) {
                            $scope.dataMap[index] = {};
                            var data = [];
                            row.forEach(function (cell, cellIndex) {
                                if(cellIndex > 0) {
                                    data.push({
                                        code: voivodenshipMap[voivodenships[cellIndex]],
                                        value: Number(cell.value)
                                    });
                                }
                            });
                            if(repoObject.name === 'Patients_by_voivodenship_allergy.saiku' && row[0].value !== '#null') {
                                $scope.dataMap[index].name = $translate.instant('T.ENUM.ALLERGY_TYPE.' + row[0].value);
                            } else {
                                $scope.dataMap[index].name = row[0].value;
                            }
                            $scope.dataMap[index].data = data;


                        }
                    });
                    $scope.options = Object.keys($scope.dataMap).map(function (index) {
                        return {
                            id: index,
                            name: $scope.dataMap[index].name
                        }
                    });
                    if(data.cellset && data.cellset[1] && data.cellset[1][1]) {
                        $scope.seriesName = data.cellset[1][1].value;
                    }
                    break;
            }
        }

        function setData() {
            $scope.data = [];
            $scope.dataMap = {};
            $scope.options = [];
            $scope.repoObject = repoObject;
            $scope.vm = {
                type: null
            };
            $scope.type = "pl";
            setHighchartsTranslations();
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.SAIKU.QUERY.SUCCESS, function (event, data) {
                saikuModel.execute(data);
            });

            $scope.$on(Event.SAIKU.EXECUTE.SUCCESS, function (event, data) {
                generateData(data);
            });

            $scope.$watch('vm.type', function (newVal) {
                if(newVal) {
                    $scope.ready = false;
                    $scope.data = $scope.dataMap[newVal].data;
                    $timeout(function () {
                        $scope.ready = true;
                    });
                }
            });
        }

        function setActions() {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.HOME);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.UI.APPLICATION.HOME_PAGE');
        }

        function initialize() {
            var uuid = saikuModel.generateId();
            saikuModel.query(uuid, repoObject.path);
        }

        function setHighchartsTranslations() {
            Highcharts.setOptions({
                lang: {
                    loading: $translate.instant("T.HIGHCHARTS.LOADING"),
                    exportButtonTitle: $translate.instant("T.HIGHCHARTS.EXPORT_BUTTON_TITLE"),
                    printButtonTitle: $translate.instant("T.HIGHCHARTS.PRINT_BUTTON_TITLE"),
                    rangeSelectorFrom: $translate.instant("T.HIGHCHARTS.RANGE_SELECTOR_FROM"),
                    rangeSelectorTo: $translate.instant("T.HIGHCHARTS.RANGE_SELECTOR_TO"),
                    rangeSelectorZoom: $translate.instant("T.HIGHCHARTS.RANGE_SELECTOR_ZOOM"),
                    downloadPNG: $translate.instant("T.HIGHCHARTS.DOWNLOAD_PNG"),
                    downloadJPEG: $translate.instant("T.HIGHCHARTS.DOWNLOAD_JPEG"),
                    downloadPDF: $translate.instant("T.HIGHCHARTS.DOWNLOAD_PDF"),
                    downloadSVG: $translate.instant("T.HIGHCHARTS.DOWNLOAD_SVG"),
                    thousandsSep: $translate.instant("T.HIGHCHARTS.THOUSANDS_SEP"),
                    decimalPoint: $translate.instant("T.HIGHCHARTS.DECIMAL_POINT"),
                    printChart: $translate.instant("T.HIGHCHARTS.PRINT_CHART")
                }
            });

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
